<template>
    <div>
        <!-- List Options -->
        <div v-show='image_count > 0'>
            <input @change='filterResults' v-model='manager.filters.media.selected' value='Images' id='has_images' type="checkbox"/>
            <label for='has_images'></label>
            <label for='has_images'>
                Images <span v-show="manager.filters.media.selected.indexOf('Images') == -1">({{image_count}})</span>
            </label>
        </div>
        <div v-show='doc_count > 0'>
            <input @change='filterResults' v-model='manager.filters.media.selected' value='Documents' id='has_docs' type="checkbox"/>
            <label for='has_docs'></label>
            <label for='has_docs'>
                Documents <span v-show="manager.filters.media.selected.indexOf('Documents') == -1">({{doc_count}})</span>
            </label>
        </div>
        <div v-show='audio_count > 0'>
            <input @change='filterResults' v-model='manager.filters.media.selected' value='Audio' id='has_audio' type="checkbox"/>
            <label for='has_audio'></label>
            <label for='has_audio'>
                Audio <span v-show="manager.filters.media.selected.indexOf('Audio') == -1">({{audio_count}})</span>
            </label>
        </div>
        <div v-show='video_count > 0'>
            <input @change='filterResults' v-model='manager.filters.media.selected' value='Video' id='has_video' type="checkbox"/>
            <label for='has_video'></label>
            <label for='has_video'>
                Video <span v-show="manager.filters.media.selected.indexOf('Video') == -1">({{video_count}})</span>
            </label>
        </div>
        <div v-show='video_count == 0 && audio_count == 0 && doc_count == 0 && image_count == 0'>
            No options apply
        </div>
    </div>
</template>

<script>
    import EventHub from '../eventHub.js'
    import FilterManager from './../filterManager.js'

    export default {
        props: ['filterResults'],
        data: function () {
            return {
                manager: FilterManager,
                image_count: 0,
                doc_count: 0,
                audio_count: 0,
                video_count: 0,
            }
        },
        created: function () {
            EventHub.$on('refresh-facets', this.sort)
        },
        beforeDestroy: function () {
            EventHub.$off('refresh-facets')
        },
        methods: {
            // Sort filter options
            sort: function () {
                var self = this
                var query = $.extend(true, {}, this.$route.query)
                query.facet = 'has_media'

                // Make request for new facets
                $.get('/api/objects', query).done(function (response) {
                    response = $.parseJSON(response)
                    var buckets = response.aggs['has_media'].buckets
                    self.image_count = _.find(buckets, {key: 'Images'}) ? _.find(buckets, {key: 'Images'}).doc_count : 0
                    self.doc_count = _.find(buckets, {key: 'Documents'}) ? _.find(buckets, {key: 'Documents'}).doc_count : 0
                    self.audio_count = _.find(buckets, {key: 'Audio'}) ? _.find(buckets, {key: 'Audio'}).doc_count : 0
                    self.video_count = _.find(buckets, {key: 'Video'}) ? _.find(buckets, {key: 'Video'}).doc_count : 0

                })
            }
        }
    }
</script>

<style scoped>
    button {
        margin-top: 10px;
    }
</style>
